import React from 'react';
import styled from 'styled-components';

import Button from '../../Components/Button';
import AutocompleteSelect from '../AutocompleteSelect';

const { FEATURE_REPORTS_NAVBAR_UI } = process.env;

const ControllerContainer = styled(({ ...rest }) => <div {...rest} />)`
    width: 80%;
    font-size: 18px;
    top: 120px;
    left: 80px;
    height: 500px;
    .report-type {
        font-style: italic;
        text-align: left;
        > div {
            margin-bottom: 8px;
            &:last-of-type {
                margin-bottom: 0;
            }
        }
    }
    .select-container {
        margin: 13px 0;
        padding: 8px 0;
        .label {
            padding: 5px 0;
        }
    }
    .button-container {
        padding: 13px;
    }
    .button-container--legacy {
        position: absolute;
        top: 487px;
    }

    @media (max-width: 768px) {
        width: 100%;
        font-size: 16px;
        top: auto;
        left: auto;
        height: auto;
        .report-type {
            font-style: italic;
            text-align: left;
            > div {
                margin-bottom: 8px;
                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }
        .select-container {
            margin: 13px 0;
            padding: 8px 0;
            .label {
                padding: 5px 0;
            }
        }
        .button-container {
            position: relative;
            top: auto;
        }
    }
`;

const ReportController = ({ displayContext, selectOptions, stepLabel, onChange, value, actions = [], isFixedOpen }) => {
    const fixedOpen = isFixedOpen ? window.innerWidth > 768 : false;
    return (
        <ControllerContainer>
            <div className="report-type">{displayContext.map((i) => i)}</div>
            <AutocompleteSelect
                options={selectOptions}
                label={stepLabel}
                onChange={onChange}
                value={value}
                fixedOpen={fixedOpen}
            />
            <div
                className={`button-container ${
                    FEATURE_REPORTS_NAVBAR_UI !== 'true' ? 'button-container--legacy' : ''
                } left-aligned`}
            >
                {actions.map((act, i) => {
                    if (act.display) {
                        return (
                            <Button onClick={act.action} key={`action-${i}`}>
                                {act.label}
                            </Button>
                        );
                    } else {
                        return null;
                    }
                })}
            </div>
        </ControllerContainer>
    );
};

export default ReportController;
